import { PaletteUtils } from './paletteUtils';
import { type RecipientResponse, TransferRecipientTypeEnum } from '@shared/api';

const FIND_SYMBOL = 'X';
const FINAL_SYMBOL = '*';
const BLOCK_DIGITS_COUNT = 4;

export class FormatUtils {
  static toPhoneFormat = (phoneAreaCode: string, phoneNumber: string) => `+${phoneAreaCode}-${phoneNumber}`;

  static toSliceNumber = (stringNumber: string, countSymbols: number = 8) => {
    if (!stringNumber) return '';

    const resultString = stringNumber
      .split('')
      .reduce<string[][]>((resultArray: string[][], item, index) => {
        const chunkIndex = Math.floor(index / BLOCK_DIGITS_COUNT);
        if (!resultArray[chunkIndex]) resultArray[chunkIndex] = [];
        resultArray[chunkIndex].push(item);
        return resultArray;
      }, [])
      .map((ch) => ch.join(''))
      .join(' ');

    const replacedString = resultString.replaceAll(FIND_SYMBOL, FINAL_SYMBOL);
    const countSpaces = Math.round(countSymbols / BLOCK_DIGITS_COUNT) - 1;

    return replacedString.slice(-(countSymbols + countSpaces));
  };

  static toMoneyFormat = (amount: number, decimalCount = 2, decimal = '.', thousands = ',') => {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? '-' : '';

    const i = parseInt(Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
    const j = i.length > 3 ? i.length % 3 : 0;

    return (
      negativeSign +
      (j ? i.substring(0, j) + thousands : '') +
      i.substring(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) +
      (decimalCount
        ? decimal +
          Math.abs(amount - parseInt(i))
            .toFixed(decimalCount)
            .slice(2)
        : '')
    );
  };

  static formatAccountNumber = (accountNumber: string) => `*${accountNumber.slice(-4)}`;

  static transactionTypeTransformation = (value: string) =>
    PaletteUtils.isVcfcPalette && value.includes('Insignia') ? value.replace('Insignia', 'VCFC ') : value;

  static getRecipientName = (recipient: RecipientResponse) => {
    if (recipient.type === TransferRecipientTypeEnum.Individual) return `${recipient.firstName.trim()} ${recipient.lastName.trim()}`.trim() || '-';
    if (recipient.type === TransferRecipientTypeEnum.Business) return recipient.companyName || '-';
    return '-';
  };
  static getRecipientInitials = (recipient: RecipientResponse) => {
    if (recipient.type === TransferRecipientTypeEnum.Individual)
      return `${recipient.firstName.trim()[0]}${recipient.lastName.trim()[0]}`.trim() || '-';
    if (recipient.type === TransferRecipientTypeEnum.Business)
      return recipient.companyName
        ? recipient.companyName
            .trim()
            .split(' ')
            .map((word) => (word?.[0] || '').toUpperCase())
            .join('')
            .slice(0, 2)
        : '-';
    return '-';
  };
}
